/**
 * Created with IntelliJ IDEA.
 * User: itkoren
 * Date: 07/20/13
 * Time: 11:41 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    // Get the $
    var $ = require("jquery");

    function promiseFactory(callback) {
        return $.Deferred(function (dfd) {
            callback({
                complete: function (context, args) {
                    dfd.resolveWith(context, [args]);
                },
                error: function (context, args) {
                    dfd.rejectWith(context, [args]);
                },
                progress: function (context, args) {
                    dfd.notifyWith(context, [args]);
                }
            });
        }).promise();
    }

    return {
        promise: promiseFactory
    };
});